import { useEffect, useState } from "react";
import useApi from "./useApi";

interface MagentoConfig {
  id: number;
  displayName: string;
  storeName: string;
  storeUrl: string;
  edition: string;
  enabled: boolean;
}

export default function useMagentoConfigs() {
  const [items, setItems] = useState<MagentoConfig[]>([]);
  const [loading, setLoading] = useState(true);
  const api = useApi();

  useEffect(() => {
    async function fetchConfigs() {
      setLoading(true);
      try {
        const resp = await api.admin.get("Magento/Configs");
        const data = await resp.json();
        setItems(Array.isArray(data) ? data : []);
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    }
    fetchConfigs();
  }, [api.admin]);

  return { items, loading };
}
